import PolicyEn from "./locale/en";
import PolicyTh from "./locale/th";
import { useTranslation } from "react-i18next";
import { checkLanguage } from "../../utility"

export default function PolicyPage() {
  const { i18n } = useTranslation("", { useSuspense: false });
  const render = () => {
    switch (checkLanguage(i18n.language)) {
      case "th":
        return <PolicyTh />;

      case "en":
        return <PolicyEn />;

      default:
        return <PolicyEn />;
    }
  };
  return <div>{render()}</div>;
}
